import React from 'react';
import Skeleton, { Bone } from '../Skeleton/Skeleton';

const Loading = () => {
    return (
        <div className="version-options--items-item">
            <Skeleton>
                <Bone type="paragraph" />
                <Bone type="paragraph" />
            </Skeleton>
        </div>
    );
};

const LoadingYears = () => {
    return (
        <div className="version-years">
            <Skeleton>
                <Bone type="box" />
                <Bone type="box" />
            </Skeleton>
        </div>
    );
};

export { Loading, LoadingYears };